import flower from './flower/index.js'
import work from './work/index.js'
import wind from './wind/index.js'
import summer from './summer/index.js'
import fall from './fall/index.js'
import wave from './wave/index.js'
import plan from './plan/index.js'
import business from './business/index.js'
import resume from './resume/index.js'
import makeup from './makeup/index.js'
import train from './train/index.js'
import smart from './smart/index.js'
import policy from './policy/index.js'
import simple from './simple/index.js'
import mount from './mount/index.js'
import sketch from './sketch/index.js'
import leaf from './leaf/index.js'
import paint from './paint/index.js'
import company from './company/index.js'
import newyear from './newyear/index.js'





export default {
	flower,
	work,
	wind,
	summer,
	fall,
	wave,
	plan,
	business,
	resume,
	makeup,
	train,
	smart,
	policy,
	simple,
	mount,
	sketch,
	leaf,
	paint,
	company,
	newyear
}